export default [
  // === Rotas originais ===
  {
    path: '/bot/create',
    name: 'bot-create',
    component: () => import('@/views/bot/bot-ia/editFlow'),
  },
  {
    path: '/bot',
    name: 'bot',
    component: () => import('@/views/bot/bot-ia/botInicio'),
  },
  {
    path: '/bot/edit/:botId',
    name: 'bot-editar',
    component: () => import('@/views/bot/bot-ia/botEditar'),
  },

  // === Novas rotas com prefixo "bot-oficial" ===
  {
    path: '/bot-oficial',
    name: 'bot-oficial',
    component: () => import('@/views/bot/flows/BotPickerPage.vue'),
  },
  {
    path: '/bot-oficial/flow/create',
    name: 'bot-oficial-flow-create',
    component: () => import('@/views/bot/flows/BotFlowEditor.vue'),
    // ✅ passar botUuid da query (quando houver)
    props: route => ({ botUuid: route.query.botUuid || null }),
  },
  {
    path: '/bot-oficial/flow/edit/:botId',
    name: 'bot-oficial-flow-edit',
    component: () => import('@/views/bot/flows/BotFlowEditor.vue'),
    props: route => ({ botId: route.params.botId, botUuid: route.query.botUuid || null }),
  },
]
